import React, { Fragment, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Input from "../components/form-components/Input";
import FormButton from "../components/form-components/FormButton.js";
import logo from "../assets/logo_wide.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	icon,
} from "@fortawesome/fontawesome-svg-core/import.macro";

function Login(props) {
	const [email, setEmail, ] = useState("");
	const [password, setPassword, ] = useState("");
	const navigate = useNavigate();
	const API_URL = process.env.REACT_APP_API_URL;
	const { setJWT } = useOutletContext();
	const { toggleRefresh } = useOutletContext();

	const signInIcon = (
		<FontAwesomeIcon
			icon={icon({ name: "lock", family: "sharp", style: "solid" })}
			className=""
		/>
	);

	const handleSubmit = (evt) => {
		evt.preventDefault();

		// build the payload 
		let payload = {
			email: email,
			password: password
		}

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify(payload),
		};

		fetch(API_URL + "/authenticate", requestOptions)
			.then((response) => response.json())
			.then((data) => {
				console.log("data", data);
				if (data.error) {
					console.log("error", data.error);
					setJWT("");
				} else {
					setJWT(data.Tokens.access_token);
					toggleRefresh(true);
					navigate("/");
				}
			});
	};



	function handlePassword(evt) {
		setPassword(evt.target.value);
	}

	function handleEmail(evt) {
		setEmail(evt.target.value);
	}

    return (
		<Fragment>
		<div className="flex flex-col items-center justify-center m-auto min-h-screen w-full bg-primary">
			{/* <div> */}
				<div className="w-full bg-card rounded-card border border-card-bd cursor-default">
					<div className="items-start max-auto text-left p-4">
						<img src={logo} alt="Logo" width="135px" className="pt-0 inline align-top" />
					</div>
					<form className="items-center justify-center max-auto text-center px-10" onSubmit={handleSubmit}>
						<div className="">
							<h1 className="text-2xl font-bold leading-tight tracking-tight text-text md:text-2sxl text-center pt-6">
							Sign in
							</h1>
							<div className="font-bold leading-tight tracking-tight text-text md:text-2sxl text-center pb-8">
							Please enter your details
							</div>
							<div>
								<Input 
									autocomplete="username" 
									name="email" 
									id="email" 
									value={email}
									onChange={handleEmail}
									className="w-[450px]"
									placeholder="Email" 
									noMarginBottom={true}
									enablePasswordToggle={true}
									required />
								<Input 
									type="password" 
									autocomplete="current-password" 
									onChange={handlePassword}
									name="password" 
									id="password" 
									value={password}
									handleChange={handlePassword}
									placeholder="Password" 
									className="w-[450px]"
									noMarginBottom={true}
									enablePasswordToggle={true}

									required />
							</div>
						</div>
						<div className="flex h-24 mt-12 pb-24 justify-end">
							<FormButton
										title="Sign in"
										type="submit"
										style="primary"
										className="w-[450px] cursor-pointer"
										icon={signInIcon}
							/>			
						</div>
					</form>
				</div>
			{/* </div> */}
		</div>
		</Fragment>
	);
}

export default Login;
